import React from "react";

const Success = () => {
  return (
    <div>
      <h1>Paymeny Success</h1>
    </div>
  );
};

export default Success;
